module.exports = "/img/digitalIcon.5bceebd3.png";